import { BaseContainerModel } from '../../base-container.model';
import {bl_cms_facilities_cal_event_link_RowClass} from '../../../dbschema';

export class FacilitiesCalendarEventLinkContainerModel implements BaseContainerModel {
  bl_cms_facilities_cal_event_link: bl_cms_facilities_cal_event_link_RowClass = new bl_cms_facilities_cal_event_link_RowClass();
}
